import { axios } from '@ben/api/axios';
import type { IModularBenefitDetail } from '@ben/shared/types/columbia';

interface SaveModularBenefitPayload {
  id: number;
  warnings?: string[];
}

type SaveModularBenefitResponse = number | SaveModularBenefitPayload;

export interface SaveModularBenefitResult {
  id: number;
  warnings: string[];
}

const unwrapSaveResponse = (
  data: SaveModularBenefitResponse | undefined
): SaveModularBenefitResult => {
  if (typeof data === 'number') {
    return { id: data, warnings: [] };
  }
  if (data && typeof data.id === 'number') {
    return { id: data.id, warnings: data.warnings ?? [] };
  }
  throw new Error('Unexpected save modular benefit response');
};

export const saveModularBenefit = async (
  data: IModularBenefitDetail,
  id?: string,
  versionId?: string
): Promise<SaveModularBenefitResult> => {
  const method = id ? 'patch' : 'post';
  const idSuffix = id ? `${id}/` : '';
  const versionSuffix = versionId ? `versions/${versionId}/` : '';
  const url = `benefits/${idSuffix}${versionSuffix}`;

  const response =
    typeof window === 'undefined'
      ? ({ data: {} } as { data: SaveModularBenefitResponse })
      : await axios.request<SaveModularBenefitResponse>({
          url,
          method,
          data,
        });
  return unwrapSaveResponse(response?.data);
};
